import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, CircularProgress, Stack, Card } from "@mui/material";

const AnnouncementStatsModal = ({ open, onClose, stats, loading }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Announcement Engagement</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
            <CircularProgress />
          </Box>
        ) : stats ? (
          <Stack spacing={2} sx={{ pt: 1 }}>
            <Card variant="outlined" sx={{ p: 2 }}>
              <Typography variant="caption" color="text.secondary">
                Total Reads (Modal Views)
              </Typography>
              <Typography variant="h4" fontWeight={700} color="primary">
                {stats.totalReads || 0}
              </Typography>
            </Card>
            <Card variant="outlined" sx={{ p: 2 }}>
              <Typography variant="caption" color="text.secondary">
                Total Dismissals
              </Typography>
              <Typography variant="h4" fontWeight={700} color="secondary">
                {stats.totalDismissals || 0}
              </Typography>
            </Card>
          </Stack>
        ) : (
          <Typography>No data found.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AnnouncementStatsModal;
